import './banner.scss';
import '../banner-raw-html/banner-raw-html.tag';
riot.tag2('banner', '<div class="banner-container"> <div class="banner-content"> <h3 class="banner-title acr-title-5"> <banner-raw-html content="{opts.bannerTitle}"></banner-raw-html> </h3> <p class="banner-description acr-paragraph-4">{opts.description}</p> </div> <div class="banner-button-container"> <button class="banner-button acr-caption-10" data-tracking="{getTrackingData()}" onclick="{clickHandler}">{opts.buttonText}</button> </div> </div>', '', '', function(opts) {
    const self = this;
    const trackingJSON = self.opts.trackingJson;
    let container;
    self.mixin('bus');

    function getTrackingData() {
      if (trackingJSON) {
        return JSON.stringify(trackingJSON);
      }
      return null;
    }

    function clickHandler() {
      self.bus.trigger(self.bus.EVENTS.BANNER.BUTTON_CLICK, {
        params: self.opts.params,
        target: self.opts.target,
        url: self.opts.url,
      });
    }

    self.clickHandler = clickHandler;

    self.on('mount', () => {
      container = self.root.querySelector('.banner-container');

      if (self.opts.backgroundColor) {
        container.style.backgroundColor = self.opts.backgroundColor;
      }

      if (self.opts.backgroundImage) {
        container.style.backgroundImage = `url(${self.opts.backgroundImage})`;
      }
    });

    self.on('update', () => {
      container = self.root.querySelector('.banner-container');

      if (container && self.opts.backgroundImage) {
        container.style.backgroundImage = `url(${self.opts.backgroundImage})`;
      } else if (container) {
        container.style.backgroundImage = '';
      }
    });
    self.getTrackingData = getTrackingData;
});
